<div class="text-secondary w-100">
  <label class="form-label mb-1">Buscar:</label>
  <div class="w-100">
    <input
      type="text"
      class="form-control w-100"
      aria-label="Search"
      (input)="onSearch($event)"
    />
  </div>
</div>
